export default __webpack_public_path__ + "static/media/08-city_preview.3e72ce0e.jpg";